import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import "../styles/VideoModal.css";

function VideoModal({ videoId, isOpen, onClose, title }) {
  const playerUrl = `https://www.youtube.com/watch?v=${videoId}`;

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="video-modal-backdrop" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="video-modal-close"
          aria-label="Close video"
          onClick={onClose}
        >
          ×
        </button>
        <div className="video-modal-header">
          <h2>{title || "Video"}</h2>
        </div>
        <div className="video-modal-player">
          {videoId ? (
            <ReactPlayer
              url={playerUrl}
              playing={isOpen}
              controls
              width="100%"
              height="100%"
              config={{
                youtube: {
                  playerVars: { showinfo: 1, rel: 0, modestbranding: 1 },
                },
              }}
            />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "white",
                background: "#333",
              }}
            >
              <p>No video ID provided</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VideoModal;
